import React from 'react';
import ReactDOM from 'react-dom';
import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import Aria from 'formvalidation/es6/plugins/Aria';
import Pagination from './Pagination';

if (document.querySelector('.media-coverage .articles')) {
    ReactDOM.render(<Pagination controlledElement={document.querySelector('.media-coverage .articles')} />, document.querySelector('.media-coverage-pagination'));
}
if (document.querySelector('.press-releases .articles')) {
    ReactDOM.render(<Pagination controlledElement={document.querySelector('.press-releases .articles')} />, document.querySelector('.press-releases-pagination'));
}
if (document.querySelector('.awards .articles')) {
    ReactDOM.render(<Pagination controlledElement={document.querySelector('.awards .articles')} />, document.querySelector('.awards-pagination'));
}
if (document.querySelector('upcoming-events .articles')) {
    ReactDOM.render(<Pagination controlledElement={document.querySelector('.upcoming-events .articles')} />, document.querySelector('.upcoming-events-pagination'));
}

const thp = document.getElementById('thank-you-page');
const formWrapper = document.getElementById('media-inquiries-form');

let errors = {};
const form = document.querySelector('.media-inquiries-form');
const captchaContainer = document.getElementById('captcha_container');

const plugins = {
    aria: new Aria(),
    bootstrap3: new Bootstrap3(),
    submitButton: new SubmitButton(),
    trigger: new Trigger({
        event: {
            email: 'blur',
        },
    }),
};

if (captchaContainer) {
    const captchaMessage = captchaContainer.getAttribute('data-fv-not-empty___message');

    plugins.recaptcha = new Recaptcha({
        element: 'captcha_container',
        siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
        message: captchaMessage,
        size: 'invisible',
    });
}

const fv = formValidation(form, {
    plugins,
    fields: {
        name: {
            validators: {
                callback: {
                    callback: (input) => {
                        if (errors.name && errors.name.message && errors.name.value === input.value) {
                            return {
                                valid: false,
                                message: errors.name.message[0],
                            };
                        }
                        return true;
                    },
                },
                notEmpty: {
                    message: form.querySelector('[name="name"]').getAttribute('data-fv-not-empty___message'),
                },
            },
        },
        email: {
            validators: {
                callback: {
                    callback: (input) => {
                        if (errors.email && errors.email.message && errors.email.value === input.value) {
                            return {
                                valid: false,
                                message: errors.email.message[0],
                            };
                        }
                        return true;
                    },
                },
                notEmpty: {
                    message: form.querySelector('[name="email"]').getAttribute('data-fv-not-empty___message'),
                },
                emailAddress: {
                    message: form.querySelector('[name="email"]').getAttribute('data-fv-email-address___message'),
                },
            },
        },
        message: {
            validators: {
                callback: {
                    callback: (input) => {
                        if (errors.message && errors.message.message && errors.message.value === input.value) {
                            return {
                                valid: false,
                                message: errors.message.message[0],
                            };
                        }
                        return true;
                    },
                },
                notEmpty: {
                    message: form.querySelector('[name="message"]').getAttribute('data-fv-not-empty___message'),
                },
            },
        },
    },
}).on('core.form.valid', () => {
    const formData = new FormData(form);
    fetch(form.action, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.messageSent === 'yes') {
                errors = {};
                thp.classList.add('visible');
                formWrapper.classList.add('hidden');
            } else {
                const responseErrors = { ...data.errors };
                errors = {
                    name: {
                        value: formData.get('name'),
                        message: responseErrors.name,
                    },
                    email: {
                        value: formData.get('email'),
                        message: responseErrors.email,
                    },
                    message: {
                        value: formData.get('message'),
                        message: responseErrors.message,
                    },
                };
                if (responseErrors.name || responseErrors.email || responseErrors.message) {
                    fv.validate();
                }
                delete responseErrors.name;
                delete responseErrors.email;
                delete responseErrors.message;
                const otherErrors = Object.entries(responseErrors)
                    .map((responseError) => responseError[1])
                    .flat();
                if (otherErrors.length > 0) {
                    document.getElementById('other-error-messages').innerHTML = otherErrors.join('<br />');
                }
            }
        })
        .catch((error) => {
            console.error(error);
        });
});
